<div class="grid ">
	<div class="col-12">
		<div class="card">
			<form>
				<div class="formgroup">
					<div class="flex justify-content-center mt-3" *ngIf="exibirSpinnerPrincipal">
						<p-progressSpinner></p-progressSpinner>
					</div>
					<div *ngIf="messagemVisivel" class="mb-5">
						<p-messages [(value)]="messages" [enableService]="false" [closable]="true"></p-messages>
					</div>
					<div class="p-fluid p-formgrid grid" *ngIf="!exibirSpinnerPrincipal && descricaoProblema">
						<div class="field col-12">
							<label class="label-superior">Problema relatado</label>
							<label class="label-inferior border-1 border-round border-gray-500 p-2">{{descricaoProblema}}</label>
						</div>
						<div class="field col-12">
							<label class="label-superior">Anexos</label>
							<div class="flex flex-nowrap overflow-x-auto justify-start gap-3">
								<div *ngFor="let item of listaEvidenciasAbertura; let i = index"
									class="relative w-8rem h-8rem">
									<img *ngIf="item.tipoMensagem === 'IMAGEM' else evidenciaArquivo"
										[src]="item.conteudo" class="object-cover w-full h-full rounded border-1 border-round border-gray-500
										 cursor-pointer" (click)="abrirImagem(item.conteudo)" />
									<ng-template #evidenciaArquivo>
										<div [pTooltip]="item.nomeArquivo ?? ''" class="flex align-items-center justify-content-center w-full h-full
											 border-1 border-round border-gray-500 cursor-pointer"
											(click)="baixarArquivo(item.conteudo, item.nomeArquivo)">
											<i [ngClass]="obterIconeArquivo(item.tipoMensagem)" class="text-4xl"></i>
										</div>

									</ng-template>
								</div>

							</div>
						</div>
						<div class="col-12">
							<p-divider></p-divider>
						</div>
						<div class="field col-12">
							<label class="label-superior">Como foi resolvido</label>
							<label class="label-inferior border-1 border-round border-gray-500 p-2">{{descricaoSolucao}}</label>
						</div>
						
						<div class="field col-12">
							<label class="label-superior">Anexos</label>
							<div class="flex flex-nowrap overflow-x-auto justify-start gap-3">
								<div *ngFor="let item of listaEvidenciasFechamento; let i = index"
									class="relative w-8rem h-8rem">
									<img *ngIf="item.tipoMensagem === 'IMAGEM' else evidenciaArquivo"
										[src]="item.conteudo" class="object-cover w-full h-full rounded border-1 border-round
										 border-gray-500 cursor-pointer" />
									<ng-template #evidenciaArquivo>
										<div [pTooltip]="item.nomeArquivo ?? ''" class="flex align-items-center
										 justify-content-center w-full h-full
											 border-1 border-round border-gray-500 cursor-pointer"
											 (click)="baixarArquivo(item.conteudo, item.nomeArquivo)">
											<i [ngClass]="obterIconeArquivo(item.tipoMensagem)" class="text-4xl"></i>
										</div>

									</ng-template>
								</div>

							</div>
						</div>

					</div>

					<div class="p-fluid p-formgrid grid justify-content-end" *ngIf="!exibirSpinnerPrincipal">
						<div class="col-12 md:col-4 flex justify-content-end">
							<button type="button" pButton icon="pi pi-arrow-left" label="Voltar"
								class="p-button-outlined md:w-9rem"
								routerLink="/rfarias/suporte/base-conhecimento"></button>
						</div>
					</div>

				</div>
			</form>
		</div>
	</div>
</div>